import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import styles from './Auth.module.css';
import OtpInput from '../../components/OtpInput';
import Button from '../../components/Button';
import { useAuth } from '../../store/AuthContext';
import { useToast } from '../../store/ToastContext';

function VerifyOtp() {
  const navigate = useNavigate();
  const location = useLocation();
  const { verifyEmail, resendOtp } = useAuth();
  const toast = useToast();
  
  const email = location.state?.email;
  const purpose = location.state?.purpose || 'registration';
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!email) {
      navigate('/register');
    }
  }, [email, navigate]);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (otp.length !== 6) {
      setError(true);
      return;
    }

    setLoading(true);
    setError(false);
    
    try {
      await verifyEmail({ email, otp_code: otp });
      toast.success('Email verified successfully! Please login.');
      navigate('/login');
    } catch (error) {
      setError(true);
      toast.error(error.message || 'Invalid OTP');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      await resendOtp(email, purpose);
      toast.success('OTP sent to your email');
      setCountdown(60);
      setOtp('');
      setError(false);
    } catch (error) {
      toast.error(error.message || 'Failed to resend OTP');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className={styles.formContainer}>
      <div className={styles.formHeader}>
        <h2 className={styles.formTitle}>Verify your email</h2>
        <p className={styles.formSubtitle}>
          We've sent a 6-digit code to<br />
          <strong>{email}</strong>
        </p>
      </div>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.otpWrapper}>
          <OtpInput
            length={6}
            value={otp}
            onChange={setOtp}
            error={error}
          />
          {error && (
            <p className={styles.errorText}>Invalid or expired code. Please try again.</p>
          )}
        </div>

        <Button type="submit" fullWidth loading={loading} disabled={otp.length !== 6}>
          Verify Email
        </Button>

        <div className={styles.resendContainer}>
          {countdown > 0 ? (
            <span className={styles.countdown}>Resend code in {countdown}s</span>
          ) : (
            <button
              type="button"
              className={styles.resendButton}
              onClick={handleResend}
              disabled={resending}
            >
              {resending ? 'Sending...' : 'Resend code'}
            </button>
          )}
        </div>
      </form>

      <p className={styles.formFooter}>
        <Link to="/login" className={styles.link}>
          Back to login
        </Link>
      </p>
    </div>
  );
}

export default VerifyOtp;
